module.exports = __webpack_public_path__ + "img/shipping.473dff97.svg";